module.exports = __webpack_public_path__ + "img/212af80a8b30b4bcd0171f5353a0d2d9.bd020b44.png";